const moment = require('moment')

// NOTE https://www.notion.so/panopli/Pricing-logistique-f3455a1332434905b35dda6e045849b7
/**
 * {Object}
 */
const dropshippingPrice = {
  orderManagementPrice: 2.10,
  skuPrice: 0.66,
}

const selfSendSupplier = '5b06affc8427184204089fa0'

const storagePricePerDay = 0.002

/**
 * @return {Number} a float with two decimal points
 * @param {Number} input the number you want to clean
 */
const cleanNumber = input => parseFloat(input.toFixed(2))

/**
 * @return {Number|Boolean} a dropShippingPrice for those orders of false if fails
 * @param {Object} order all the orders passed on the considered period
 * @param {Object} pricing the override for the pricing
 * @param {Number} pricing.orderManagementPrice the price per (sub) order
 * @param {Number} pricing.skuPrice the price per sku in the order
 */
const dropshippingPriceCalculation = (order) => {
  try {
    const {
      orderManagementPrice,
      skuPrice,
    } = dropshippingPrice
    if(order.regrouped) {
      return 0
    }
    return order.subOrders
      // NOTE filter out subOrders that are sent by the seller
      .filter(s => (String(s.supplier) !== selfSendSupplier))
      .filter(so => so.products.some(product => product.fromStock))
      .map((so) => {
        const products = so.products
          .filter(product => product.fromStock)
        const price = orderManagementPrice + (products.length * skuPrice)
        console.log(price)
        return cleanNumber(price)
      })
      .reduce((acc, curr) => acc + curr, 0)
  } catch (error) {
    return false
  }
}

const remainingStock = (stocks) => {
  return stocks.filter(s => (String(s.shipperId) !== selfSendSupplier)).reduce((acc, curr) => acc + curr.qty, 0)
}

const orderStockByDays = (order, start) => {
  const days = moment(order.createdAt).diff(start, 'days')
  return order.subOrders
    // NOTE filter out subOrders that are sent by the seller
    .filter(s => String(s.supplier) !== selfSendSupplier)
    .filter(s => s.products.some(p => p.fromStock))
    .reduce((acc, subOrder) => acc + subOrder.products
      .filter(p => p.fromStock)
      .reduce((a, p) => a + p.quantity, 0), 0) * days
}

const ordersStockByDays = (orders, start) => orders
  .filter(o => o.subOrders.some(s => s.products.some(p => p.fromStock)))
  .map(order => orderStockByDays(order, start))
  .reduce((a, c) => a + c, 0)

const storagePriceCalculation = (orders = [], periodLength = 30, stocks) => {
  const stock = remainingStock(stocks)
  const remainingStockPrice = stock * storagePricePerDay * periodLength
  const periodStart = moment().add(-periodLength, 'days')
  const daysOfStock = ordersStockByDays(orders, periodStart)
  const orderStockPrice = daysOfStock * storagePricePerDay
  const result = remainingStockPrice + orderStockPrice
  return cleanNumber(result)
}

/**
 * @typedef {Object} Result
 * @property {Number} dropShippingPrice - The dropshipping price for this period
 * @property {Number} storagePrice - The price for storage that period
 */

/**
 * @param {Array} products the products for that shop
 * @param {Array} orders the orders for that period
 * @return {Result} the calculation result
 */
const invoiceCalculator = (products = [], orders = [], stocks = []) => {
  const periodLength = moment().diff(moment().add(-1, 'month'), 'days')
  return {
    dropShippingPrice: cleanNumber(orders.map(dropshippingPriceCalculation).reduce((acc, cur) => acc + cur, 0)),
    storagePrice: storagePriceCalculation(orders, periodLength, stocks),
  }
}

module.exports = {
  invoiceCalculator,
  dropshippingPriceCalculation,
  dropshippingPrice,
  cleanNumber,
  storagePriceCalculation,
  storagePricePerDay,
  selfSendSupplier,
}
